import { ConversationUsersMap } from "../../../api/api-hooks/comments/useFetchComments";
import { Comment } from "../../../api/api-hooks/comments/useCreateComment";
import { isEmpty } from "underscore";
import { ReactionEmojis } from "./CommentReactions";
import { Popover, Whisper } from "rsuite";
import AvatarAndName from "./AvatarAndName";

export default function ReactionsList({
  comment,
  handleReaction,
  usersMap,
}: {
  comment: Comment;
  handleReaction: ((reaction: string) => void) | undefined;
  usersMap: ConversationUsersMap;
}) {
  if (isEmpty(comment?.Reactions)) return null;

  return (
    <>
      {Object.keys(comment.Reactions).map((name) => {
        const users = comment.Reactions[name];

        if (users.length < 1) return null;

        const reactionData = ReactionEmojis[name];
        const css =
          "d-flex border rounded bg-white align-items-center pl-1 text-sm cursor-pointer";
        const onClick = handleReaction ? () => handleReaction(name) : undefined;

        let Emoji = null;

        if (reactionData.emoji) {
          Emoji = (
            <div className={css} onClick={onClick} style={{ paddingTop: 2 }}>
              {reactionData.emoji}
              <div className="font-weight-bold text-xs mx-1">
                {users.length}
              </div>
            </div>
          );
        } else if (reactionData.icon) {
          Emoji = (
            <div className={css}>
              <i className={`${reactionData.icon}`} onClick={onClick} />
              <div className="font-weight-bold text-xs ml-1 mr-2">
                {users.length}
              </div>
            </div>
          );
        }

        if (!Emoji) return null;

        return (
          <Whisper
            key={name}
            trigger={"hover"}
            delayOpen={500}
            placement="bottomEnd"
            speaker={
              <Popover
                className="sidebar-popover px-3 py-2"
                style={{ minWidth: "unset" }}
              >
                <h5 className="text-dark">{name}</h5>
                {users.map((userID) => (
                  <AvatarAndName key={userID} user={usersMap[userID]} />
                ))}
              </Popover>
            }
          >
            {Emoji}
          </Whisper>
        );
      })}
    </>
  );
}
